import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const InputNode = ({ id, data }) => {
  const [currName, setCurrName] = useState(
    data?.inputName || id.replace('customInput-', 'input_')
  );
  const [inputType, setInputType] = useState(data.inputType || 'Text');

  const config = {
    title: 'Input',
    fields: [
      {
        name: 'name',
        type: 'text',
        label: 'Name',
        value: currName,
        onChange: (e) => setCurrName(e.target.value),
        placeholder: 'Enter input name',
      },
      {
        name: 'type',
        type: 'select',
        label: 'Type',
        value: inputType,
        onChange: (e) => setInputType(e.target.value),
        options: ['Text', 'File'],
      },
    ],
    handles: [
      {
        type: 'source',
        position: Position.Right,
        id: `${id}-value`,
      },
    ],
    width: 220,
    height: 120,
  };

  return <BaseNode id={id} data={data} config={config} />;
};